const types = {
	//Get Template name
	GET_STATUS: "GET_STATUS",
};

export default types;
